/**
 * P0-DISCOVERY-07 — local share counter used to surface the Ambassador
 * discovery banner after 3 successful shares. Pure localStorage; no
 * new tables, no new APIs.
 */
const KEY = "vs:viral:shareSuccessCount";

export function getShareSuccessCount(): number {
  if (typeof window === "undefined") return 0;
  try {
    return Number(window.localStorage.getItem(KEY) ?? 0) || 0;
  } catch {
    return 0;
  }
}

export function bumpShareSuccess(): number {
  if (typeof window === "undefined") return 0;
  const next = getShareSuccessCount() + 1;
  try {
    window.localStorage.setItem(KEY, String(next));
  } catch {
    /* noop */
  }
  try {
    window.dispatchEvent(
      new CustomEvent("vs:share:success-count", { detail: { count: next } }),
    );
  } catch {
    /* noop */
  }
  return next;
}

export function subscribeShareSuccess(handler: (count: number) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const fn = (e: Event) => {
    const c = (e as CustomEvent<{ count: number }>).detail?.count;
    if (typeof c === "number") handler(c);
  };
  window.addEventListener("vs:share:success-count", fn as EventListener);
  return () => window.removeEventListener("vs:share:success-count", fn as EventListener);
}
